module.exports = __webpack_public_path__ + "media/bell_ring2.d564eecc.mp3";